import template from './messageOutbound.html';

const messageOutboundComponent = {
  restrict: 'E',
  template
};

export default messageOutboundComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/messageOutbound.component.js
 **/